import { Link, useRouterState } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { breadcrumbs, type NavArea } from '../navigation.ts';

/** O caminho de navegação acima da tela (some na página inicial). */
export function Breadcrumbs({ areas }: { areas: NavArea[] }) {
  const { t } = useTranslation();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const crumbs = breadcrumbs(areas, pathname);
  if (crumbs.length === 0) return null;
  return (
    <nav aria-label={t('nav.breadcrumb')} className="-mb-3 text-xs text-muted">
      <ol className="flex flex-wrap items-center gap-1.5">
        {crumbs.map((c, i) => (
          <li key={c.key} className="flex items-center gap-1.5">
            {i > 0 && <span aria-hidden>›</span>}
            {c.to ? (
              <Link to={c.to} className="hover:text-ink hover:underline">
                {t(c.key)}
              </Link>
            ) : (
              <span aria-current={i === crumbs.length - 1 ? 'page' : undefined}>{t(c.key)}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
